/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Go_To_First_TitleInputs */



/**
* | output |
* | --- |
* | "Go to first event" |
*
* @param {Video_Export_Preview_Go_To_First_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_go_to_first_title = /** @type {((inputs?: Video_Export_Preview_Go_To_First_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Go_To_First_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller au premier evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gehe zum ersten Ereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai al primo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к первому событию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al primer evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前往第一个活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最初のイベントへ移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहले इवेंट पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vá para o primeiro evento.")
	return /** @type {LocalizedString} */ ("Go to first event")
});